import React, { useEffect, useState } from "react";
import styles from "./MisReportsGraphs.module.scss";
import ReactECharts from "echarts-for-react";
import { commonVaribles } from "src/constants/constVariables";

const LogisticSheetPlantwiseChart = ({ plantWiseSheet }) => {

  const [chartOptions, setChartOptions] = useState({});
  
  const getChartOptions = () => {
		return {
    title: {
      text: "Logistics Sheets Plantwise",
      left: "left",
      textStyle: {
        color: "#000000", // Set title text color to black
        fontWeight: "600",
        fontFamily: "OpensansRegular",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: function (params) {
        let result = "<div>" + params[0].name + "<br/>";
        params.forEach(function (item) {
          let color = item.seriesName === "Percentage" ? "#F3D17A" : "#51CC5D";
          if (item.seriesName === "Percentage") {
            result +=
              '<span style="display:inline-block;width:10px;height:10px;border-radius:20px;background-color:' +
              color +
              ';margin-right:5px;"></span>' +
              item.seriesName +
              " : " +
              item.value +
              "%" +
              "<br/>";
          } else {
            {
              result +=
                '<span style="display:inline-block;width:10px;height:10px;border-radius:20px;background-color:' +
                color +
                ';margin-right:5px;"></span>' +
                item.seriesName +
                " : " +
                item.value +
                "<br/>";
            }
          }
        });
        result += "</div>";
        return result;
      },
    },
    legend: {
      data: ["Recommendation count", "Percentage"],
      right: "1%",
      orient: "vertical",
    },
    xAxis: [
      {
        type: "category",
        data: plantWiseSheet?.header_array,
        splitLine: {
          show: false, // Hide the separation line along the x-axis
        },
        axisLabel: {
          width: 100,
          rotate: 40,
          interval: 0,
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        splitLine: {
          show: false, // Hide the grid lines on the y-axis
        },
        axisLine: {
          show: true, // Show y-axis line
        },
      },
    ],
    grid: {
      backgroundColor: "#FFFF00", // Set the background color of the grid
    },
    series: [
      {
        name: "Recommendation count",
        type: "bar",
        data: plantWiseSheet?.total_recommended_sheet_array,
        barGap: "50%", // Set the gap between bars
        barWidth: window.innerWidth <= 600 ? 15 : 30,
        itemStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: "#57DA65" },
              { offset: 0.5, color: "#51CC5D" },
              { offset: 1, color: "#46A46C" },
            ],
          },
          barBorderRadius: 10,
          borderWidth: 1,
        },
        label: {
          show: true, // Show label on top of the bar
          position: "top", // Position the label on top of the bar
          color: "black", // Label color
          fontSize: "12%", // Label font size
        },
      },
      {
        name: "Percentage",
        type: "bar",
        data: plantWiseSheet?.total_recommended_sheet_perc_array,
        barWidth: window.innerWidth <= 600 ? 15 : 30,
        itemStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: "#F3D17A" },
              { offset: 0.5, color: "#FABC74" },
              { offset: 1, color: "#F1B379" },
            ],
          },
          barBorderRadius: 10,
          borderWidth: 1,
        },
        label: {
          show: true, // Show label on top of the bar
          position: "top", // Position the label on top of the bar
          color: "black", // Label color
          fontSize: "12%", // Label font size
          formatter: function (params) {
            return `${params.value} %`;
          },
        },
      },
    ],
  };
};

  useEffect(() => {
    setChartOptions(getChartOptions());

    // Update chart options on window resize
    const handleResize = () => {
      setChartOptions(getChartOptions());
    };

    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [plantWiseSheet]);

  return (
    <>
      {plantWiseSheet?.header_array ? (
        <ReactECharts
          option={chartOptions}
          notMerge={true}
          className={styles.chart}
        />
      ) : (
        <div className={styles.containers}> {commonVaribles.data_not_found}</div>
      )}
    </>
  );
};

export default LogisticSheetPlantwiseChart;
